import { render, staticRenderFns } from "./PartnerPage.vue?vue&type=template&id=3a7b7d88&"
import script from "./PartnerPage.vue?vue&type=script&lang=js&"
export * from "./PartnerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports